import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timeliner" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "slider" }, null, -1)

import * as sys from '@/sys'
import * as lib from '@/lib'
//import * as time from '@/logic/_infra/time'
import 'nouislider/dist/nouislider.css';
import noUiSlider, { API } from 'nouislider';
import { onMounted, onUnmounted, watch } from 'vue';
import * as arrays from '@/lib/array.lib'
import { minuteCalc as mc} from '@/logic/_infra/time';


export default /*#__PURE__*/_defineComponent({
  __name: 'EndeavoursComponent',
  props: {
    values: {},
    start: {},
    end: {}
  },
  emits: ['updated'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

// When using a bundler such as Webpack,
// include both noUiSlider and its stylesheet.
// Either import the default:

// Or the namespace:
//import * as noUiSlider from 'nouislider';
const emit = __emit
__expose({ addInterval: addInterval, sliderDelete: deleteInterval })

const model: { control: API | null, buffer: number[] } = { control: null, buffer: [] }

const props = __props;

onMounted(() => {

    if (props.values?.length > 1) createControl(props.values, props.start, props.end);
})

onUnmounted(function(){

    if (model.control != null) model.control.destroy()
})

watch(props, () => {

    //console.log('watch:props')

    if (arrays.isEqual(props.values, model.buffer)) console.log('watch:props - negative');

    if (arrays.isEqual(props.values, model.buffer)) return;

    //console.log('watch:props - values are not equal')

    //console.log('values')
    //console.log(props.values)
    //console.log('buffer')
    //console.log(model.buffer)

    if (props.values.length == model.buffer.length) {


        //console.log('A')

        if (model.control != null) {

            //console.log('D')

            model.buffer.length = 0

            props.values.map((x) => x).forEach(y=>model.buffer.push(y));
            model.control.set(props.values, false);
        }

        else createControl(props.values, props.start, props.end)
    }
    else {


        //console.log('B')

        if (model.control != null) {

            model.control.destroy();

            model.control = null;

            model.buffer.length = 0

            props.values.map((x) => x).forEach(x=>model.buffer.push(x)); //clone array

            //console.log('C')
        }



        createControl(props.values, props.start, props.end)
    }
})

function addInterval(): boolean {


    let values: number[] = [];

    if (model.control != null) {

        values = get_array()

        

        if (values.length > 0) {

            const ending = values[values.length - 1];

            if (ending > props.end) return false; //1740(end of perion) - 15 - 15

            values.push(ending + 15);
            values.push(ending + 75);
        }


        model.control.destroy();
    }
    else {

        let minutes = (lib.dayMinute() / 15) * 15 - 300;
        values.push(minutes);
        values.push(minutes + 60);
    }


    //props.values = values;

    createControl(values, props.start, props.end);

    emit("updated", values)

    return true;
}

function get_array(){

    return (model!.control!.get(true) as number[]).map(v=>Math.round(v));
}

function deleteInterval(): boolean {

    console.log('delete - initial')

    if (model.control === null) return false;

    const value = get_array()

    if (value.length > 2) {

        console.log('delete - >2')

        const ending = value[value.length - 1];

        value.length = value.length - 2;

        model.control.destroy();

        createControl(value, props.start, props.end);

        emit("updated", value)

    }
    else 
    {
        console.log('delete - <= 2')

        model.control.destroy();
        model.control = null;
        emit("updated", [])
    }

    return true;

}




function createControl(value: number[], start:number, end:number) {

    sys.info('Timeline control - Created')

    model.buffer.length = 0
    value.map((x) => x).forEach(x=>model.buffer.push(x));

    if (value.length <= 1) return;

    var element = document.getElementById('slider');

    if (element != null) {

        model.control = noUiSlider.create(element, {
            start: value,
            connect: true,
            range: {
                'min': start,
                'max': end
            },
            step: 15,
            margin: 15,
            orientation: 'vertical',
            tooltips: {
                to: mc.minutesToDayTime,
            },

        });

        model.control.on('set', function () {

            if (model.control == null) return;

            const values = get()

            if (!arrays.isEqual(values, model.buffer)) emit("updated", values);

            model.buffer.length = 0

            values.forEach(v=>model.buffer.push(v))

            

            //#trace
            //console.log('on set:')
            //console.log(model.buffer)


        })

        const connect = element.querySelectorAll('.noUi-connect');
        //var classes = ['c-1-color', 'c-2-color', 'c-3-color', 'c-4-color', 'c-5-color'];

        //slider-off

        for (var i = 0; i < connect.length; i++) {

            if (i % 2 != 0) connect[i].classList.add('slider-off');

        }


    }
}

function get(): number[] {

    if (model.control == null) return []

    const values = model.control.get(true) as number[]

    values.forEach((e, i) => values[i] = Math.round(e))

    return values;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", { class: "text-center" }, [
      _createElementVNode("i", {
        onClick: addInterval,
        class: "bi bi-plus-circle clickable"
      })
    ]),
    _createElementVNode("p", { class: "text-center" }, [
      _createElementVNode("i", {
        class: "bi bi-trash clickable",
        onClick: deleteInterval
      })
    ]),
    _hoisted_2
  ]))
}
}

})